export { type ContentProps, default as Content } from './Content';
